<!-- Zweck: Stellt die HTML-Struktur für shop einkaufs statitik web details component im Frontend bereit. -->
@if (statistik) {
  <table class="table table-striped">
    <thead>
    <tr>
      <th>Einkaufsstatistik Web</th>
      <th style="text-align: center">Summe</th>
      @for (month of months; track month) {
        <th style="text-align: center">
          {{month}}
        </th>
      }
    </tr>
    </thead>
    <tbody>
    @for(y of statistik; track y) {
        <tr>
          <td>
            @if (y.year == highlightYear) {
              <strong>
                {{y.year}}
              </strong>
            } @else {
              {{y.year}}
            }
          </td>
          <td style="text-align: center; width: 90px">
            {{y.sum}}
          </td>
          @for (month of months; track month) {
            <td style="text-align: center; width: 70px">
              @if (y.year == highlightMonthYear && month == highlightMonthMonth) {
                <strong>
                  {{y.months[month]}}
                </strong>
              } @else {
                {{y.months[month]}}
              }
            </td>
          }
        </tr>
    }
    </tbody>
  </table>
}
